<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">{{ editing ? 'Edit general term' : 'Add a general term' }}</h2>
  <p class="dialog-subtitle">
    @if (editing) {
      The term key is immutable once created — only its description can change.
    } @else {
      Must be the exact JSON key a notarised export event carries for this field.
    }
  </p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Term</mat-label>
    <input matInput [(ngModel)]="term" name="term" placeholder="bizStep" [disabled]="!!editing" />
    <mat-hint>Case-sensitive, e.g. "bizStep" — not "BIZ_STEP"</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description (optional)</mat-label>
    <input matInput [(ngModel)]="description" name="description" placeholder="What this term means" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
